import React, { FC } from 'react'
import styles from 'styles/components/template.module.scss'
import { NavButton } from 'components/Button'
import { LargeMenuCard } from 'components/Card'
import { Spacer } from 'components/Utility'

const MessageTemplate: FC = () => {
  return (
    <div className={styles.standard}>
      <Spacer size={40} />
      <LargeMenuCard
        description={'お気に入り登録されているお客さま全体にメッセージを配信します'}
        iconPath={'/icon/white/large_message.svg'}
        title={'全体配信'}
        url={'/customer/message/create'}
      />
      <Spacer size={24} />
      <LargeMenuCard
        description={'送信予約中や、過去配信したメッセージの一覧を表示します'}
        iconPath={'/icon/white/large_message.svg'}
        title={'メッセージリスト'}
        url={'/customer/message/list'}
      />
      <Spacer size={24} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/'} />
      <Spacer size={40} />
    </div>
  )
}

export default MessageTemplate
